import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {store} from './stores/store';
import VoucherPayment from './components/VoucherPayment'
import * as Sentry from "@sentry/react";
const MIX_SENTRY_LARAVEL_DSN = process.env.MIX_SENTRY_LARAVEL_DSN;
Sentry.init({
  dsn: MIX_SENTRY_LARAVEL_DSN
});

let root = document.getElementById('root');

ReactDOM.render(
    <Provider store={store}>
        <VoucherPayment
            type_id={parseInt(root.dataset.voucher_type_id)}
            price={parseInt(root.dataset.price)}
            locale={root.dataset.locale}
            user_id={root.dataset.user_id}
            session={root.dataset.session}
        />
    </Provider>
    , root
);

